import { Action } from "@/api-schema-enums";
import { Can } from "@/casl-provider";
import { useVehicleByVinQuery } from "@/common/api/vehicle/use-vehicle-by-vin.query";
import { ErrorPage } from "@/components/error-page/error-page";
import { Loader, LoaderSize } from "@/components/ui/loader";
import { useTranslation } from "react-i18next";
import { Redirect, useParams } from "wouter";

export function VehicleVinRedirectView() {
  return (
    <Can I={Action.Read} a="Vehicle">
      <VehicleVinRedirect />
    </Can>
  );
}

function VehicleVinRedirect() {
  const { t } = useTranslation(["masterdata"]);
  const params = useParams<{ vin: string }>();
  const vin = params.vin;

  const { data, isPending, isError } = useVehicleByVinQuery(vin);

  if (isPending) {
    return (
      <div className="flex min-h-100 items-center justify-center">
        <Loader size={LoaderSize.Medium} />
      </div>
    );
  }

  if (isError || !data?.uuid) {
    return (
      <ErrorPage
        title={t("masterdata:VehicleNotFound")}
        message={t("masterdata:VehicleDoesNotExist")}
        description={t("masterdata:CheckVehicleIdOrContactSupport")}
        backTo="~/masterdata/vehicle"
        backToLabel={t("masterdata:BackToVehicleOverview")}
      />
    );
  }

  return <Redirect to={`~/masterdata/vehicle/${data.uuid}`} replace />;
}
